import { render } from "./DemoResult.vue?vue&type=template&id=49cadf27&scoped=true"
import script from "./DemoResult.vue?vue&type=script&lang=js"
export * from "./DemoResult.vue?vue&type=script&lang=js"

import "@/styles/components/_demoResult.scss?vue&type=style&index=0&id=49cadf27&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-49cadf27"

export default script